export default defineNuxtRouteMiddleware((to) => {
  const { trackPageViewed } = useTrack();
  trackPageViewed(to.fullPath);
});
